(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initBlackBeeMarquee() {

    const marquees = document.querySelectorAll(
      '.blackbee-marquee:not([data-marquee-ready])'
    );

    marquees.forEach(function (marquee) {

      marquee.setAttribute('data-marquee-ready', 'true');

      const track = marquee.querySelector(
        '.blackbee-marquee__track'
      );

      const originalGroup = marquee.querySelector(
        '.blackbee-marquee__group'
      );

      if (!track || !originalGroup) return;


      /* ---------------------------------
         DUPLICATE CONTENT
      --------------------------------- */

      const clone = originalGroup.cloneNode(true);

      clone.setAttribute(
        'aria-hidden',
        'true'
      );

      track.appendChild(clone);


      /* ---------------------------------
         SPEED
      --------------------------------- */

      const speed =
        parseInt(
          marquee.dataset.marqueeSpeed,
          10
        ) || 30;

      track.style.setProperty(
        '--marquee-speed',
        speed + 's'
      );


      /* ---------------------------------
         HOVER PAUSE
      --------------------------------- */

      marquee.addEventListener(
        'mouseenter',
        function () {
          track.style.animationPlayState =
            'paused';
        }
      );

      marquee.addEventListener(
        'mouseleave',
        function () {
          track.style.animationPlayState =
            'running';
        }
      );

    });

  }


  /* Initial load */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initBlackBeeMarquee
    );

  } else {

    initBlackBeeMarquee();

  }


  /* Shopify Theme Editor */

  document.addEventListener(
    'shopify:section:load',
    initBlackBeeMarquee
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
